module.exports = __webpack_public_path__ + "img/icon-long-1-3.e2cff51c.png";